var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 491.5 491.5",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 245.76,
    x2: 245.76,
    y1: 35.51,
    y2: 456.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#32b0c4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#3fe398",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M240.3 317h169.3v-60.5h-21.4v39.1H261.6v-39.1h-21.4V317zm174.1 9.6H235.5c-2.7 0-4.8-2.1-4.8-4.8v-70.1c0-2.7 2.1-4.8 4.8-4.8h31c2.6 0 4.8 2.2 4.8 4.8V286h107.4v-34.3c0-2.7 2.1-4.8 4.8-4.8h31c2.7 0 4.8 2.2 4.8 4.8v70.1c-.1 2.7-2.2 4.8-4.9 4.8zM298.8 217.1l28.1 40 28.1-40h-17.7v-84.4h-20.8v84.4zm28.1 53.2c-1.6 0-3-.8-3.9-2l-37.3-53.2c-1-1.5-1.2-3.4-.3-5 .8-1.6 2.5-2.6 4.3-2.6H307V128c0-2.7 2.1-4.8 4.8-4.8h30.4c2.6 0 4.8 2.1 4.8 4.8v79.6h17.3c1.8 0 3.4 1 4.3 2.6.8 1.6.7 3.5-.3 5L331 268.4c-1.1 1.1-2.6 1.9-4.1 1.9zM270.7 93.8H210c-8.9 0-16.1 7.2-16.1 16.1V340c0 8.9 7.2 16.1 16.1 16.1H439.9c8.9 0 16.1-7.2 16.1-16.1V109.9c0-8.9-7.2-16.1-16.1-16.1zm-4.8-9.6V50.3c0-8.1-6.6-14.7-14.8-14.7H50.2c-8.1 0-14.8 6.6-14.8 14.8v336.1h230.4v-20.7H210c-14.2 0-25.7-11.5-25.7-25.7V110c0-14.2 11.5-25.7 25.7-25.7zM135.5 419.3a6.7 6.7 0 0 0 0 13.4H166c3.7 0 6.6-3 6.6-6.6 0-3.7-3-6.7-6.7-6.7zm30.4 22.9h-30.5c-9 0-16.3-7.3-16.3-16.2 0-9 7.3-16.3 16.2-16.3h30.5c9 0 16.2 7.3 16.2 16.3.2 8.9-7.1 16.2-16.1 16.2zm1.6-378.7h-33.6c-2.7 0-4.8-2.1-4.8-4.8s2.1-4.8 4.8-4.8h33.6c2.7 0 4.8 2.2 4.8 4.8s-2.2 4.8-4.8 4.8zm-132 332.4v45.4c0 8.1 6.6 14.8 14.7 14.8h200.9c8.1 0 14.8-6.6 14.8-14.7V396z",
    "data-original": "url(#a)",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppDownload);
export default __webpack_public_path__ + "static/media/appDownload.673c7d28bfa92cdfde8b3a4c3954018f.svg";
export { ForwardRef as ReactComponent };